import altTitleEditor from './altTitleEditor'

window.DatoCmsPlugin.init(plugin => altTitleEditor(plugin, document, window))
